/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddUserToShowEventCommentDenylist,
    BatchSortShowEventFeaturedShows,
    BatchSortShowEventsRequest,
    BatchSortShowTicketsRequest,
    CommentUpvoteItem,
    CreateSellerApplicationTemplateRequest,
    CreateSellerApplicationsRequest,
    CreateShowEventRequest,
    CreateShowEventResponse,
    CreateShowEventTemplateDto,
    CreateShowTicketRequest,
    CreateTicketOrderRequestV1,
    CreateTicketOrderRequestV2,
    CreateTicketOrderResponse,
    EditSellerApplicationTemplateRequest,
    EditShowEventRequest,
    EditShowEventResponse,
    EditShowTicketRequest,
    IdResponse,
    MostUpvotedCommentResponse,
    MostUpvotedCommentResponseWrapper,
    PatchShowEventFeaturedShowRequest,
    PatchShowEventRequest,
    PreviewTicketOrderRequest,
    PreviewTicketOrderResponse,
    SendCommentRequest,
    SetShowCustomizationRequest,
    ShowEventGenerateTokenRequest,
    ShowEventTokensResponse,
    WaveFollowersToWatchRequest,
    WavedToUserEnterRequest,
} from '../models';

export interface ShowEventApiControllerActivateShowEventRequest {
    showEventId: string;
}

export interface ShowEventApiControllerAddUserToLiveStreamCommentDenylistRequest {
    showEventId: string;
    userId: string;
    addUserToShowEventCommentDenylist: AddUserToShowEventCommentDenylist;
}

export interface ShowEventApiControllerApproveSellerApplicationRequest {
    eventId: string;
    id: string;
}

export interface ShowEventApiControllerBatchSortFeaturedShowRequest {
    eventId: string;
    batchSortShowEventFeaturedShows: BatchSortShowEventFeaturedShows;
}

export interface ShowEventApiControllerBatchSortShowEventsRequest {
    batchSortShowEventsRequest: BatchSortShowEventsRequest;
}

export interface ShowEventApiControllerBatchSortShowTicketsRequest {
    eventId: string;
    batchSortShowTicketsRequest: BatchSortShowTicketsRequest;
}

export interface ShowEventApiControllerCloseShowEventRequest {
    showEventId: string;
}

export interface ShowEventApiControllerCreateSellerApplicationRequest {
    eventId: string;
    createSellerApplicationsRequest: CreateSellerApplicationsRequest;
}

export interface ShowEventApiControllerCreateSellerApplicationTemplateRequest {
    eventId: string;
    createSellerApplicationTemplateRequest: CreateSellerApplicationTemplateRequest;
}

export interface ShowEventApiControllerCreateShowEventRequest {
    createShowEventRequest: CreateShowEventRequest;
}

export interface ShowEventApiControllerCreateShowEventTemplateRequest {
    eventId: string;
    createShowEventTemplateDto: CreateShowEventTemplateDto;
}

export interface ShowEventApiControllerCreateShowTicketOrderRequest {
    eventId: string;
    ticketId: string;
    createTicketOrderRequestV1: CreateTicketOrderRequestV1;
}

export interface ShowEventApiControllerCreateShowTicketOrderV2Request {
    eventId: string;
    ticketId: string;
    createTicketOrderRequestV2: CreateTicketOrderRequestV2;
}

export interface ShowEventApiControllerCreateShowTicketsRequest {
    eventId: string;
    createShowTicketRequest: CreateShowTicketRequest;
}

export interface ShowEventApiControllerDeactivateShowEventRequest {
    showEventId: string;
}

export interface ShowEventApiControllerDeleteCommentRequest {
    showEventId: string;
    commentId: string;
}

export interface ShowEventApiControllerDeleteShowEventFeaturedShowRequest {
    eventId: string;
    featuredShowId: string;
}

export interface ShowEventApiControllerEditSellerApplicationTemplateRequest {
    eventId: string;
    templateId: string;
    editSellerApplicationTemplateRequest: EditSellerApplicationTemplateRequest;
}

export interface ShowEventApiControllerEditShowEventRequest {
    showEventId: string;
    editShowEventRequest: EditShowEventRequest;
}

export interface ShowEventApiControllerEditShowEventTemplateRequest {
    eventId: string;
    templateId: string;
    createShowEventTemplateDto: CreateShowEventTemplateDto;
}

export interface ShowEventApiControllerEditShowTicketsRequest {
    eventId: string;
    ticketId: string;
    editShowTicketRequest: EditShowTicketRequest;
}

export interface ShowEventApiControllerGenerateTokensRequest {
    showEventId: string;
    showEventGenerateTokenRequest: ShowEventGenerateTokenRequest;
}

export interface ShowEventApiControllerGetCommentUpvotesRequest {
    showEventId: string;
    sinceMinutesAgo?: number;
}

export interface ShowEventApiControllerGetMostUpvotedCommentRequest {
    showEventId: string;
}

export interface ShowEventApiControllerGetMostUpvotedCommentV2Request {
    showEventId: string;
}

export interface ShowEventApiControllerOpenShowEventRequest {
    showEventId: string;
}

export interface ShowEventApiControllerPatchShowEventRequest {
    eventId: string;
    patchShowEventRequest: PatchShowEventRequest;
}

export interface ShowEventApiControllerPatchShowEventFeaturedShowRequest {
    eventId: string;
    featuredShowId: string;
    patchShowEventFeaturedShowRequest: PatchShowEventFeaturedShowRequest;
}

export interface ShowEventApiControllerPreviewShowTicketOrderRequest {
    eventId: string;
    ticketId: string;
    previewTicketOrderRequest: PreviewTicketOrderRequest;
}

export interface ShowEventApiControllerRejectSellerApplicationStatusRequest {
    eventId: string;
    id: string;
}

export interface ShowEventApiControllerRemoveAutoFeaturedPropertyRequest {
    eventId: string;
    featuredShowId: string;
}

export interface ShowEventApiControllerSendCommentRequest {
    showEventId: string;
    commentId: string;
    sendCommentRequest: SendCommentRequest;
}

export interface ShowEventApiControllerSendShowTicketConfirmationMailRequest {
    eventId: string;
    ticketOrderId: string;
}

export interface ShowEventApiControllerSetShowCustomizationRequest {
    eventId: string;
    setShowCustomizationRequest: SetShowCustomizationRequest;
}

export interface ShowEventApiControllerUpvoteCommentRequest {
    showEventId: string;
    commentId: string;
}

export interface ShowEventApiControllerWaveFollowersToWatchRequest {
    showEventId: string;
    waveFollowersToWatchRequest: WaveFollowersToWatchRequest;
}

export interface ShowEventApiControllerWavedToUserEnterRequest {
    showEventId: string;
    wavedToUserEnterRequest: WavedToUserEnterRequest;
}

/**
 * 
 */
export class ShowEventApi extends runtime.BaseAPI {

    /**
     */
    async showEventApiControllerActivateShowEventRaw(requestParameters: ShowEventApiControllerActivateShowEventRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerActivateShowEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}:activate`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerActivateShowEvent(requestParameters: ShowEventApiControllerActivateShowEventRequest): Promise<void> {
        await this.showEventApiControllerActivateShowEventRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerAddUserToLiveStreamCommentDenylistRaw(requestParameters: ShowEventApiControllerAddUserToLiveStreamCommentDenylistRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerAddUserToLiveStreamCommentDenylist.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling showEventApiControllerAddUserToLiveStreamCommentDenylist.');
        }

        if (requestParameters.addUserToShowEventCommentDenylist === null || requestParameters.addUserToShowEventCommentDenylist === undefined) {
            throw new runtime.RequiredError('addUserToShowEventCommentDenylist','Required parameter requestParameters.addUserToShowEventCommentDenylist was null or undefined when calling showEventApiControllerAddUserToLiveStreamCommentDenylist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}/blocked/{userId}`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addUserToShowEventCommentDenylist,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerAddUserToLiveStreamCommentDenylist(requestParameters: ShowEventApiControllerAddUserToLiveStreamCommentDenylistRequest): Promise<void> {
        await this.showEventApiControllerAddUserToLiveStreamCommentDenylistRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerApproveSellerApplicationRaw(requestParameters: ShowEventApiControllerApproveSellerApplicationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerApproveSellerApplication.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling showEventApiControllerApproveSellerApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/seller-applications/{id}:approve`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerApproveSellerApplication(requestParameters: ShowEventApiControllerApproveSellerApplicationRequest): Promise<void> {
        await this.showEventApiControllerApproveSellerApplicationRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerBatchSortFeaturedShowRaw(requestParameters: ShowEventApiControllerBatchSortFeaturedShowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerBatchSortFeaturedShow.');
        }

        if (requestParameters.batchSortShowEventFeaturedShows === null || requestParameters.batchSortShowEventFeaturedShows === undefined) {
            throw new runtime.RequiredError('batchSortShowEventFeaturedShows','Required parameter requestParameters.batchSortShowEventFeaturedShows was null or undefined when calling showEventApiControllerBatchSortFeaturedShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/featured-shows:batch-sort`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchSortShowEventFeaturedShows,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerBatchSortFeaturedShow(requestParameters: ShowEventApiControllerBatchSortFeaturedShowRequest): Promise<void> {
        await this.showEventApiControllerBatchSortFeaturedShowRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerBatchSortShowEventsRaw(requestParameters: ShowEventApiControllerBatchSortShowEventsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.batchSortShowEventsRequest === null || requestParameters.batchSortShowEventsRequest === undefined) {
            throw new runtime.RequiredError('batchSortShowEventsRequest','Required parameter requestParameters.batchSortShowEventsRequest was null or undefined when calling showEventApiControllerBatchSortShowEvents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events:batch-sort`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchSortShowEventsRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerBatchSortShowEvents(requestParameters: ShowEventApiControllerBatchSortShowEventsRequest): Promise<void> {
        await this.showEventApiControllerBatchSortShowEventsRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerBatchSortShowTicketsRaw(requestParameters: ShowEventApiControllerBatchSortShowTicketsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerBatchSortShowTickets.');
        }

        if (requestParameters.batchSortShowTicketsRequest === null || requestParameters.batchSortShowTicketsRequest === undefined) {
            throw new runtime.RequiredError('batchSortShowTicketsRequest','Required parameter requestParameters.batchSortShowTicketsRequest was null or undefined when calling showEventApiControllerBatchSortShowTickets.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/tickets:batch-sort`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchSortShowTicketsRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerBatchSortShowTickets(requestParameters: ShowEventApiControllerBatchSortShowTicketsRequest): Promise<void> {
        await this.showEventApiControllerBatchSortShowTicketsRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerCloseShowEventRaw(requestParameters: ShowEventApiControllerCloseShowEventRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerCloseShowEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}:close`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerCloseShowEvent(requestParameters: ShowEventApiControllerCloseShowEventRequest): Promise<void> {
        await this.showEventApiControllerCloseShowEventRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerCreateSellerApplicationRaw(requestParameters: ShowEventApiControllerCreateSellerApplicationRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerCreateSellerApplication.');
        }

        if (requestParameters.createSellerApplicationsRequest === null || requestParameters.createSellerApplicationsRequest === undefined) {
            throw new runtime.RequiredError('createSellerApplicationsRequest','Required parameter requestParameters.createSellerApplicationsRequest was null or undefined when calling showEventApiControllerCreateSellerApplication.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/seller-applications`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createSellerApplicationsRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showEventApiControllerCreateSellerApplication(requestParameters: ShowEventApiControllerCreateSellerApplicationRequest): Promise<IdResponse> {
        const response = await this.showEventApiControllerCreateSellerApplicationRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showEventApiControllerCreateSellerApplicationTemplateRaw(requestParameters: ShowEventApiControllerCreateSellerApplicationTemplateRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerCreateSellerApplicationTemplate.');
        }

        if (requestParameters.createSellerApplicationTemplateRequest === null || requestParameters.createSellerApplicationTemplateRequest === undefined) {
            throw new runtime.RequiredError('createSellerApplicationTemplateRequest','Required parameter requestParameters.createSellerApplicationTemplateRequest was null or undefined when calling showEventApiControllerCreateSellerApplicationTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/seller-applications-templates`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createSellerApplicationTemplateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showEventApiControllerCreateSellerApplicationTemplate(requestParameters: ShowEventApiControllerCreateSellerApplicationTemplateRequest): Promise<IdResponse> {
        const response = await this.showEventApiControllerCreateSellerApplicationTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showEventApiControllerCreateShowEventRaw(requestParameters: ShowEventApiControllerCreateShowEventRequest): Promise<runtime.ApiResponse<CreateShowEventResponse>> {
        if (requestParameters.createShowEventRequest === null || requestParameters.createShowEventRequest === undefined) {
            throw new runtime.RequiredError('createShowEventRequest','Required parameter requestParameters.createShowEventRequest was null or undefined when calling showEventApiControllerCreateShowEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createShowEventRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showEventApiControllerCreateShowEvent(requestParameters: ShowEventApiControllerCreateShowEventRequest): Promise<CreateShowEventResponse> {
        const response = await this.showEventApiControllerCreateShowEventRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showEventApiControllerCreateShowEventTemplateRaw(requestParameters: ShowEventApiControllerCreateShowEventTemplateRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerCreateShowEventTemplate.');
        }

        if (requestParameters.createShowEventTemplateDto === null || requestParameters.createShowEventTemplateDto === undefined) {
            throw new runtime.RequiredError('createShowEventTemplateDto','Required parameter requestParameters.createShowEventTemplateDto was null or undefined when calling showEventApiControllerCreateShowEventTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/templates`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createShowEventTemplateDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showEventApiControllerCreateShowEventTemplate(requestParameters: ShowEventApiControllerCreateShowEventTemplateRequest): Promise<IdResponse> {
        const response = await this.showEventApiControllerCreateShowEventTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showEventApiControllerCreateShowTicketOrderRaw(requestParameters: ShowEventApiControllerCreateShowTicketOrderRequest): Promise<runtime.ApiResponse<CreateTicketOrderResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerCreateShowTicketOrder.');
        }

        if (requestParameters.ticketId === null || requestParameters.ticketId === undefined) {
            throw new runtime.RequiredError('ticketId','Required parameter requestParameters.ticketId was null or undefined when calling showEventApiControllerCreateShowTicketOrder.');
        }

        if (requestParameters.createTicketOrderRequestV1 === null || requestParameters.createTicketOrderRequestV1 === undefined) {
            throw new runtime.RequiredError('createTicketOrderRequestV1','Required parameter requestParameters.createTicketOrderRequestV1 was null or undefined when calling showEventApiControllerCreateShowTicketOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/tickets/{ticketId}/orders`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"ticketId"}}`, encodeURIComponent(String(requestParameters.ticketId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTicketOrderRequestV1,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showEventApiControllerCreateShowTicketOrder(requestParameters: ShowEventApiControllerCreateShowTicketOrderRequest): Promise<CreateTicketOrderResponse> {
        const response = await this.showEventApiControllerCreateShowTicketOrderRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showEventApiControllerCreateShowTicketOrderV2Raw(requestParameters: ShowEventApiControllerCreateShowTicketOrderV2Request): Promise<runtime.ApiResponse<CreateTicketOrderResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerCreateShowTicketOrderV2.');
        }

        if (requestParameters.ticketId === null || requestParameters.ticketId === undefined) {
            throw new runtime.RequiredError('ticketId','Required parameter requestParameters.ticketId was null or undefined when calling showEventApiControllerCreateShowTicketOrderV2.');
        }

        if (requestParameters.createTicketOrderRequestV2 === null || requestParameters.createTicketOrderRequestV2 === undefined) {
            throw new runtime.RequiredError('createTicketOrderRequestV2','Required parameter requestParameters.createTicketOrderRequestV2 was null or undefined when calling showEventApiControllerCreateShowTicketOrderV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/show-events/{eventId}/tickets/{ticketId}/orders`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"ticketId"}}`, encodeURIComponent(String(requestParameters.ticketId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTicketOrderRequestV2,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showEventApiControllerCreateShowTicketOrderV2(requestParameters: ShowEventApiControllerCreateShowTicketOrderV2Request): Promise<CreateTicketOrderResponse> {
        const response = await this.showEventApiControllerCreateShowTicketOrderV2Raw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showEventApiControllerCreateShowTicketsRaw(requestParameters: ShowEventApiControllerCreateShowTicketsRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerCreateShowTickets.');
        }

        if (requestParameters.createShowTicketRequest === null || requestParameters.createShowTicketRequest === undefined) {
            throw new runtime.RequiredError('createShowTicketRequest','Required parameter requestParameters.createShowTicketRequest was null or undefined when calling showEventApiControllerCreateShowTickets.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/tickets`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createShowTicketRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showEventApiControllerCreateShowTickets(requestParameters: ShowEventApiControllerCreateShowTicketsRequest): Promise<IdResponse> {
        const response = await this.showEventApiControllerCreateShowTicketsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showEventApiControllerDeactivateShowEventRaw(requestParameters: ShowEventApiControllerDeactivateShowEventRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerDeactivateShowEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}:deactivate`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerDeactivateShowEvent(requestParameters: ShowEventApiControllerDeactivateShowEventRequest): Promise<void> {
        await this.showEventApiControllerDeactivateShowEventRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerDeleteCommentRaw(requestParameters: ShowEventApiControllerDeleteCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerDeleteComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling showEventApiControllerDeleteComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}/comments/{commentId}`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerDeleteComment(requestParameters: ShowEventApiControllerDeleteCommentRequest): Promise<void> {
        await this.showEventApiControllerDeleteCommentRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerDeleteShowEventFeaturedShowRaw(requestParameters: ShowEventApiControllerDeleteShowEventFeaturedShowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerDeleteShowEventFeaturedShow.');
        }

        if (requestParameters.featuredShowId === null || requestParameters.featuredShowId === undefined) {
            throw new runtime.RequiredError('featuredShowId','Required parameter requestParameters.featuredShowId was null or undefined when calling showEventApiControllerDeleteShowEventFeaturedShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/featured-shows/{featuredShowId}`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"featuredShowId"}}`, encodeURIComponent(String(requestParameters.featuredShowId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerDeleteShowEventFeaturedShow(requestParameters: ShowEventApiControllerDeleteShowEventFeaturedShowRequest): Promise<void> {
        await this.showEventApiControllerDeleteShowEventFeaturedShowRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerEditSellerApplicationTemplateRaw(requestParameters: ShowEventApiControllerEditSellerApplicationTemplateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerEditSellerApplicationTemplate.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling showEventApiControllerEditSellerApplicationTemplate.');
        }

        if (requestParameters.editSellerApplicationTemplateRequest === null || requestParameters.editSellerApplicationTemplateRequest === undefined) {
            throw new runtime.RequiredError('editSellerApplicationTemplateRequest','Required parameter requestParameters.editSellerApplicationTemplateRequest was null or undefined when calling showEventApiControllerEditSellerApplicationTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/seller-applications-templates/{templateId}`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editSellerApplicationTemplateRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerEditSellerApplicationTemplate(requestParameters: ShowEventApiControllerEditSellerApplicationTemplateRequest): Promise<void> {
        await this.showEventApiControllerEditSellerApplicationTemplateRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerEditShowEventRaw(requestParameters: ShowEventApiControllerEditShowEventRequest): Promise<runtime.ApiResponse<EditShowEventResponse>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerEditShowEvent.');
        }

        if (requestParameters.editShowEventRequest === null || requestParameters.editShowEventRequest === undefined) {
            throw new runtime.RequiredError('editShowEventRequest','Required parameter requestParameters.editShowEventRequest was null or undefined when calling showEventApiControllerEditShowEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editShowEventRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showEventApiControllerEditShowEvent(requestParameters: ShowEventApiControllerEditShowEventRequest): Promise<EditShowEventResponse> {
        const response = await this.showEventApiControllerEditShowEventRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showEventApiControllerEditShowEventTemplateRaw(requestParameters: ShowEventApiControllerEditShowEventTemplateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerEditShowEventTemplate.');
        }

        if (requestParameters.templateId === null || requestParameters.templateId === undefined) {
            throw new runtime.RequiredError('templateId','Required parameter requestParameters.templateId was null or undefined when calling showEventApiControllerEditShowEventTemplate.');
        }

        if (requestParameters.createShowEventTemplateDto === null || requestParameters.createShowEventTemplateDto === undefined) {
            throw new runtime.RequiredError('createShowEventTemplateDto','Required parameter requestParameters.createShowEventTemplateDto was null or undefined when calling showEventApiControllerEditShowEventTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/templates/{templateId}`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters.templateId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createShowEventTemplateDto,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerEditShowEventTemplate(requestParameters: ShowEventApiControllerEditShowEventTemplateRequest): Promise<void> {
        await this.showEventApiControllerEditShowEventTemplateRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerEditShowTicketsRaw(requestParameters: ShowEventApiControllerEditShowTicketsRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerEditShowTickets.');
        }

        if (requestParameters.ticketId === null || requestParameters.ticketId === undefined) {
            throw new runtime.RequiredError('ticketId','Required parameter requestParameters.ticketId was null or undefined when calling showEventApiControllerEditShowTickets.');
        }

        if (requestParameters.editShowTicketRequest === null || requestParameters.editShowTicketRequest === undefined) {
            throw new runtime.RequiredError('editShowTicketRequest','Required parameter requestParameters.editShowTicketRequest was null or undefined when calling showEventApiControllerEditShowTickets.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/tickets/{ticketId}`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"ticketId"}}`, encodeURIComponent(String(requestParameters.ticketId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editShowTicketRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerEditShowTickets(requestParameters: ShowEventApiControllerEditShowTicketsRequest): Promise<void> {
        await this.showEventApiControllerEditShowTicketsRaw(requestParameters);
    }

    /**
     * Public API
     */
    async showEventApiControllerGenerateTokensRaw(requestParameters: ShowEventApiControllerGenerateTokensRequest): Promise<runtime.ApiResponse<ShowEventTokensResponse>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerGenerateTokens.');
        }

        if (requestParameters.showEventGenerateTokenRequest === null || requestParameters.showEventGenerateTokenRequest === undefined) {
            throw new runtime.RequiredError('showEventGenerateTokenRequest','Required parameter requestParameters.showEventGenerateTokenRequest was null or undefined when calling showEventApiControllerGenerateTokens.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}:generateTokens`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.showEventGenerateTokenRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async showEventApiControllerGenerateTokens(requestParameters: ShowEventApiControllerGenerateTokensRequest): Promise<ShowEventTokensResponse> {
        const response = await this.showEventApiControllerGenerateTokensRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async showEventApiControllerGetCommentUpvotesRaw(requestParameters: ShowEventApiControllerGetCommentUpvotesRequest): Promise<runtime.ApiResponse<Array<CommentUpvoteItem>>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerGetCommentUpvotes.');
        }

        const queryParameters: any = {};

        if (requestParameters.sinceMinutesAgo !== undefined) {
            queryParameters['sinceMinutesAgo'] = requestParameters.sinceMinutesAgo;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}/comment-upvotes`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async showEventApiControllerGetCommentUpvotes(requestParameters: ShowEventApiControllerGetCommentUpvotesRequest): Promise<Array<CommentUpvoteItem>> {
        const response = await this.showEventApiControllerGetCommentUpvotesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async showEventApiControllerGetMostUpvotedCommentRaw(requestParameters: ShowEventApiControllerGetMostUpvotedCommentRequest): Promise<runtime.ApiResponse<MostUpvotedCommentResponse>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerGetMostUpvotedComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}/comments:getMostUpvoted`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async showEventApiControllerGetMostUpvotedComment(requestParameters: ShowEventApiControllerGetMostUpvotedCommentRequest): Promise<MostUpvotedCommentResponse> {
        const response = await this.showEventApiControllerGetMostUpvotedCommentRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async showEventApiControllerGetMostUpvotedCommentV2Raw(requestParameters: ShowEventApiControllerGetMostUpvotedCommentV2Request): Promise<runtime.ApiResponse<MostUpvotedCommentResponseWrapper>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerGetMostUpvotedCommentV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v2/show-events/{showEventId}/comments:getMostUpvoted`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async showEventApiControllerGetMostUpvotedCommentV2(requestParameters: ShowEventApiControllerGetMostUpvotedCommentV2Request): Promise<MostUpvotedCommentResponseWrapper> {
        const response = await this.showEventApiControllerGetMostUpvotedCommentV2Raw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showEventApiControllerOpenShowEventRaw(requestParameters: ShowEventApiControllerOpenShowEventRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerOpenShowEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}:open`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerOpenShowEvent(requestParameters: ShowEventApiControllerOpenShowEventRequest): Promise<void> {
        await this.showEventApiControllerOpenShowEventRaw(requestParameters);
    }

    /**
     * only update featuredStoreStackName
     */
    async showEventApiControllerPatchShowEventRaw(requestParameters: ShowEventApiControllerPatchShowEventRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerPatchShowEvent.');
        }

        if (requestParameters.patchShowEventRequest === null || requestParameters.patchShowEventRequest === undefined) {
            throw new runtime.RequiredError('patchShowEventRequest','Required parameter requestParameters.patchShowEventRequest was null or undefined when calling showEventApiControllerPatchShowEvent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchShowEventRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * only update featuredStoreStackName
     */
    async showEventApiControllerPatchShowEvent(requestParameters: ShowEventApiControllerPatchShowEventRequest): Promise<void> {
        await this.showEventApiControllerPatchShowEventRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerPatchShowEventFeaturedShowRaw(requestParameters: ShowEventApiControllerPatchShowEventFeaturedShowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerPatchShowEventFeaturedShow.');
        }

        if (requestParameters.featuredShowId === null || requestParameters.featuredShowId === undefined) {
            throw new runtime.RequiredError('featuredShowId','Required parameter requestParameters.featuredShowId was null or undefined when calling showEventApiControllerPatchShowEventFeaturedShow.');
        }

        if (requestParameters.patchShowEventFeaturedShowRequest === null || requestParameters.patchShowEventFeaturedShowRequest === undefined) {
            throw new runtime.RequiredError('patchShowEventFeaturedShowRequest','Required parameter requestParameters.patchShowEventFeaturedShowRequest was null or undefined when calling showEventApiControllerPatchShowEventFeaturedShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/featured-shows/{featuredShowId}`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"featuredShowId"}}`, encodeURIComponent(String(requestParameters.featuredShowId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchShowEventFeaturedShowRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerPatchShowEventFeaturedShow(requestParameters: ShowEventApiControllerPatchShowEventFeaturedShowRequest): Promise<void> {
        await this.showEventApiControllerPatchShowEventFeaturedShowRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerPreviewShowTicketOrderRaw(requestParameters: ShowEventApiControllerPreviewShowTicketOrderRequest): Promise<runtime.ApiResponse<PreviewTicketOrderResponse>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerPreviewShowTicketOrder.');
        }

        if (requestParameters.ticketId === null || requestParameters.ticketId === undefined) {
            throw new runtime.RequiredError('ticketId','Required parameter requestParameters.ticketId was null or undefined when calling showEventApiControllerPreviewShowTicketOrder.');
        }

        if (requestParameters.previewTicketOrderRequest === null || requestParameters.previewTicketOrderRequest === undefined) {
            throw new runtime.RequiredError('previewTicketOrderRequest','Required parameter requestParameters.previewTicketOrderRequest was null or undefined when calling showEventApiControllerPreviewShowTicketOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/tickets/{ticketId}/orders:preview`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"ticketId"}}`, encodeURIComponent(String(requestParameters.ticketId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.previewTicketOrderRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showEventApiControllerPreviewShowTicketOrder(requestParameters: ShowEventApiControllerPreviewShowTicketOrderRequest): Promise<PreviewTicketOrderResponse> {
        const response = await this.showEventApiControllerPreviewShowTicketOrderRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showEventApiControllerRejectSellerApplicationStatusRaw(requestParameters: ShowEventApiControllerRejectSellerApplicationStatusRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerRejectSellerApplicationStatus.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling showEventApiControllerRejectSellerApplicationStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/seller-applications/{id}:reject`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerRejectSellerApplicationStatus(requestParameters: ShowEventApiControllerRejectSellerApplicationStatusRequest): Promise<void> {
        await this.showEventApiControllerRejectSellerApplicationStatusRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerRemoveAutoFeaturedPropertyRaw(requestParameters: ShowEventApiControllerRemoveAutoFeaturedPropertyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerRemoveAutoFeaturedProperty.');
        }

        if (requestParameters.featuredShowId === null || requestParameters.featuredShowId === undefined) {
            throw new runtime.RequiredError('featuredShowId','Required parameter requestParameters.featuredShowId was null or undefined when calling showEventApiControllerRemoveAutoFeaturedProperty.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/featured-shows/{featuredShowId}:removeAutoFeatured`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"featuredShowId"}}`, encodeURIComponent(String(requestParameters.featuredShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerRemoveAutoFeaturedProperty(requestParameters: ShowEventApiControllerRemoveAutoFeaturedPropertyRequest): Promise<void> {
        await this.showEventApiControllerRemoveAutoFeaturedPropertyRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerSendCommentRaw(requestParameters: ShowEventApiControllerSendCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerSendComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling showEventApiControllerSendComment.');
        }

        if (requestParameters.sendCommentRequest === null || requestParameters.sendCommentRequest === undefined) {
            throw new runtime.RequiredError('sendCommentRequest','Required parameter requestParameters.sendCommentRequest was null or undefined when calling showEventApiControllerSendComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}/comments/{commentId}`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sendCommentRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerSendComment(requestParameters: ShowEventApiControllerSendCommentRequest): Promise<void> {
        await this.showEventApiControllerSendCommentRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerSendShowTicketConfirmationMailRaw(requestParameters: ShowEventApiControllerSendShowTicketConfirmationMailRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerSendShowTicketConfirmationMail.');
        }

        if (requestParameters.ticketOrderId === null || requestParameters.ticketOrderId === undefined) {
            throw new runtime.RequiredError('ticketOrderId','Required parameter requestParameters.ticketOrderId was null or undefined when calling showEventApiControllerSendShowTicketConfirmationMail.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}/ticket-orders/{ticketOrderId}:send-confirmation-mail`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))).replace(`{${"ticketOrderId"}}`, encodeURIComponent(String(requestParameters.ticketOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerSendShowTicketConfirmationMail(requestParameters: ShowEventApiControllerSendShowTicketConfirmationMailRequest): Promise<void> {
        await this.showEventApiControllerSendShowTicketConfirmationMailRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerSetShowCustomizationRaw(requestParameters: ShowEventApiControllerSetShowCustomizationRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.eventId === null || requestParameters.eventId === undefined) {
            throw new runtime.RequiredError('eventId','Required parameter requestParameters.eventId was null or undefined when calling showEventApiControllerSetShowCustomization.');
        }

        if (requestParameters.setShowCustomizationRequest === null || requestParameters.setShowCustomizationRequest === undefined) {
            throw new runtime.RequiredError('setShowCustomizationRequest','Required parameter requestParameters.setShowCustomizationRequest was null or undefined when calling showEventApiControllerSetShowCustomization.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{eventId}:setShowCustomization`.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters.eventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.setShowCustomizationRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerSetShowCustomization(requestParameters: ShowEventApiControllerSetShowCustomizationRequest): Promise<void> {
        await this.showEventApiControllerSetShowCustomizationRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerUpvoteCommentRaw(requestParameters: ShowEventApiControllerUpvoteCommentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerUpvoteComment.');
        }

        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling showEventApiControllerUpvoteComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}/comments/{commentId}:upvote`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerUpvoteComment(requestParameters: ShowEventApiControllerUpvoteCommentRequest): Promise<void> {
        await this.showEventApiControllerUpvoteCommentRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerWaveFollowersToWatchRaw(requestParameters: ShowEventApiControllerWaveFollowersToWatchRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerWaveFollowersToWatch.');
        }

        if (requestParameters.waveFollowersToWatchRequest === null || requestParameters.waveFollowersToWatchRequest === undefined) {
            throw new runtime.RequiredError('waveFollowersToWatchRequest','Required parameter requestParameters.waveFollowersToWatchRequest was null or undefined when calling showEventApiControllerWaveFollowersToWatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}:waveFollowers`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.waveFollowersToWatchRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerWaveFollowersToWatch(requestParameters: ShowEventApiControllerWaveFollowersToWatchRequest): Promise<void> {
        await this.showEventApiControllerWaveFollowersToWatchRaw(requestParameters);
    }

    /**
     */
    async showEventApiControllerWavedToUserEnterRaw(requestParameters: ShowEventApiControllerWavedToUserEnterRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.showEventId === null || requestParameters.showEventId === undefined) {
            throw new runtime.RequiredError('showEventId','Required parameter requestParameters.showEventId was null or undefined when calling showEventApiControllerWavedToUserEnter.');
        }

        if (requestParameters.wavedToUserEnterRequest === null || requestParameters.wavedToUserEnterRequest === undefined) {
            throw new runtime.RequiredError('wavedToUserEnterRequest','Required parameter requestParameters.wavedToUserEnterRequest was null or undefined when calling showEventApiControllerWavedToUserEnter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/show-events/{showEventId}:wavedToUserEnter`.replace(`{${"showEventId"}}`, encodeURIComponent(String(requestParameters.showEventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.wavedToUserEnterRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showEventApiControllerWavedToUserEnter(requestParameters: ShowEventApiControllerWavedToUserEnterRequest): Promise<void> {
        await this.showEventApiControllerWavedToUserEnterRaw(requestParameters);
    }

}
